/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { Button, Typography } from '@mui/material';
import { InputLabel, Textarea } from 'components/elements';
import { useDeviceDetect } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function AppointmentCancellationReason({ onCancelAppointment, onClose, ...restProps }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { data: brandingData } = useSelector((state) => state.branding);
  const { handleSubmit, control, watch } = useForm({
    mode: 'onSubmit',
    defaultValues: restProps,
  });
  const selectedReason = watch('reason');
  const { isDesktop } = useDeviceDetect();

  return (
    <>
      {!isDesktop && <img className={classes.mobileIcon} src={brandingData.icon} alt="Mobile Logo Icon" />}
      <Typography className={classes.modalHeader} variant="h5" component="h5">
        {`${t('cancel_appointment')}?`}
      </Typography>
      <form className={classes.cancelAppointmentForm} onSubmit={handleSubmit(onCancelAppointment(selectedReason))}>
        <div className={classes.formDescription}>
          <Typography className={classes.subtitleText} variant="body1" component="p">
            {`${t('cancelling_the_appointment_may_subject_you_to_a_cancellation_fee')}.`}
          </Typography>
        </div>
        <Controller
          name="reason"
          control={control}
          render={({ field: { ref, ...restField }, fieldState: { error } }) => (
            <Textarea label={<InputLabel text={t('reason_for_cancellation')} />} hasLimitCounter={false} error={!!error} {...restField} helperText={error ? error.message : null} />
          )}
        />
      </form>
      <div className={classes.formControls}>
        <Button onClick={onClose} variant="outlined" color="error" size="large">
          <Typography variant="body1" component="span">
            {t('close')}
          </Typography>
        </Button>
        <Button className={classes.confirmButton} onClick={handleSubmit(onCancelAppointment(selectedReason || ''))} variant="contained" color="error" size="large">
          <Typography variant="body1" component="span">
            {t('cancel_appointment')}
          </Typography>
        </Button>
      </div>
    </>
  );
}

AppointmentCancellationReason.propTypes = {
  onCancelAppointment: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AppointmentCancellationReason;
